/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const token = AB.TOKEN;

if (token) {
  $.ajaxSettings.headers = { token: token }
}



// WEBPACK FOOTER //
// ./src/appBackend/utils/ajaxSetting.js